import { apiProductionPlans } from './apiProductionPlans'
import { apiProductionReports } from './apiProductionReports'
import { apiProductionSockets } from './apiProductionSockets'
import { apiProductionStages } from './apiProductionStages'
import { apiProductionSimulations } from './apiProductionSimulations'
import { apiProductionMachines } from './apiProductionMachines'
import { apiTabletPlans } from './apiTabletPlans'
import { apiTabletErrors } from './apiTabletErrors'
import { apiProductionUnits } from './apiProductionUnits'
import { apiProductionOrders } from './apiProductionOrders'
import { apiSemiProductSocketAssignments } from './apiSemiProductSocketAssignments'
import { apiPromarkLabels } from './apiPromarkLabels'

const apiProduction = {
	...apiProductionPlans,
	...apiProductionReports,
	...apiProductionSockets,
	...apiProductionStages,
	...apiProductionSimulations,
	...apiProductionMachines,
	...apiTabletPlans,
	...apiTabletErrors,
	...apiProductionUnits,
	...apiProductionOrders,
	...apiSemiProductSocketAssignments,
	...apiPromarkLabels,
}

export { apiProduction }
